import { Link } from "react-router-dom";
import { learnIndexCards } from "@/mocks/learn";
import { learnSubGuides } from "@/mocks/learnSubGuides";
import { paidGuides } from "@/mocks/guides";
import { googleFormUrl } from "@/mocks/contact";

const socialLinks = [
  { id: "instagram", icon: "ri-instagram-line", label: "Instagram" },
  { id: "x", icon: "ri-twitter-x-line", label: "X" },
  { id: "youtube", icon: "ri-youtube-line", label: "YouTube" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-content px-5 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,0.85fr)] lg:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-plane-line text-[18px]" />
              </span>
              <span className="font-heading text-[17px] font-bold tracking-tight text-foreground-950">
                ゼロからアメリカ留学
              </span>
            </Link>
            <p className="mt-4 text-[12.5px] leading-[1.9] text-foreground-600">
              エージェントを使わずにアメリカへ渡った現役コミカレ生が、テキサス州のコミュニティカレッジ留学から4年制大学への編入準備までを発信しています。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {socialLinks.map((social) => (
                <a
                  key={social.id}
                  href="#"
                  aria-label={social.label}
                  title={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-700"
                >
                  <i className={`${social.icon} text-[16px]`} />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="無料で学ぶ">
            <p className="flex items-center gap-1.5 font-heading text-[12px] font-bold text-foreground-950">
              <i className="ri-book-open-line text-[13px] text-primary-600" />
              無料で学ぶ
            </p>
            <ul className="mt-4 space-y-2.5">
              {learnIndexCards.map((card) => (
                <li key={card.slug}>
                  <Link
                    to={`/learn/${card.slug}`}
                    className="whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {card.title}
                  </Link>
                </li>
              ))}
              {learnSubGuides.map((guide) => (
                <li key={guide.slug} className="pl-3.5">
                  <Link
                    to={`/learn/${guide.slug}`}
                    className="inline-flex items-center gap-1.5 text-[11.5px] text-foreground-500 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-corner-down-right-line text-[11px]" />
                    {guide.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="有料ガイド">
            <p className="flex items-center gap-1.5 font-heading text-[12px] font-bold text-foreground-950">
              <i className="ri-lock-line text-[13px] text-accent-600" />
              有料ガイド
            </p>
            <ul className="mt-4 space-y-2.5">
              {paidGuides.map((guide) => (
                <li key={guide.slug}>
                  <Link
                    to={`/guides/${guide.slug}`}
                    className="flex items-start gap-1.5 text-[12px] leading-[1.7] text-foreground-600 transition-colors hover:text-accent-700"
                  >
                    {guide.title}
                    <span className="mt-[2px] shrink-0 rounded-full bg-background-100 px-1.5 py-[1px] text-[9.5px] font-semibold text-foreground-500">
                      準備中
                    </span>
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/guides"
                  className="mt-1 inline-flex items-center gap-1 whitespace-nowrap text-[11.5px] font-semibold text-primary-700 transition-colors hover:text-primary-800"
                >
                  ガイド一覧を見る
                  <i className="ri-arrow-right-line text-[12px]" />
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="サイトについて">
            <p className="flex items-center gap-1.5 font-heading text-[12px] font-bold text-foreground-950">
              <i className="ri-compass-3-line text-[13px] text-primary-600" />
              サイトについて
            </p>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
                >
                  ホーム
                </Link>
              </li>
              <li>
                <a
                  href="https://note.com/mypace_diary"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
                >
                  留学ブログ（note）
                  <i className="ri-external-link-line text-[11px]" />
                </a>
              </li>
              <li>
                <Link
                  to="/about"
                  className="whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
                >
                  運営者について
                </Link>
              </li>
              <li>
                {googleFormUrl ? (
                  <a
                    href={googleFormUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    お問い合わせ
                    <span className="rounded-full bg-primary-100 px-1.5 py-[1px] text-[9.5px] font-semibold text-primary-800">
                      無料
                    </span>
                    <i className="ri-external-link-line text-[11px]" />
                  </a>
                ) : (
                  <Link
                    to="/#contact"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    お問い合わせ
                    <i className="ri-mail-line text-[11px]" />
                  </Link>
                )}
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 space-y-1.5 border-t border-background-200 pt-6 text-[11px] leading-[1.85] text-foreground-500">
          <p>
            当サイトは個人が運営する情報サイトです。掲載内容は公式情報ではないため、出願・申請の前に必ず学校・公的機関の公式サイトを確認してください。
          </p>
          <p>
            制度・必要書類・基準点・学費などは学校ごとに異なり、変更される場合があります。画像はイメージです。
          </p>
        </div>

        <div className="mt-5 flex flex-col gap-2 border-t border-background-200 pt-5 text-[12px] text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; 2026 ゼロからアメリカ留学</p>
          <p className="text-foreground-400">
            Study Abroad in the USA — made by a student, for students.
          </p>
        </div>
      </div>
    </footer>
  );
}